import { render, staticRenderFns } from "./InsetText.vue?vue&type=template&id=38187399&"
import script from "./InsetText.vue?vue&type=script&lang=js&"
export * from "./InsetText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports